/**
 * Returns the timeout value sent in the explicit forms response xml. It throws an error if mulitple Timeout nodes are present
 *
 * @export
 * @param {Document} xmlData
 * @return {*}  {(number | null)}
 */
export function getTimeoutValue(requirementsXml: string): number | null {
	if (!requirementsXml) {
		return null;
	}
	const xmlData = new DOMParser().parseFromString(requirementsXml, 'text/xml');
	const TimeoutNode = Array.from(xmlData.getElementsByTagName('Timeout'));
	if (TimeoutNode.length > 1) {
		throw new Error("Can't have more than one Timeout node");
	}
	if (TimeoutNode.length === 0) {
		return null;
	}
	return parseInt(TimeoutNode[0].textContent);
}
